#import "../fragments/inbox-user-fragment.graphql"

mutation ReassignThread($input: ThreadReassignInput!) {
    threadReassign(input: $input) {
        thread {
            id
        }
        owner {
            ...InboxUserFragment
        }
    }
}
